import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const MosaicCardImage = styled.img<React.CSSProperties>`
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  height: ${196 * Screen.widthRatio}px;
  left: ${1 * Screen.widthRatio}px;
  position: absolute;
  width: ${348 * Screen.widthRatio}px;
  top: ${1 * Screen.widthRatio}px;
`;

MosaicCardImage.defaultProps = {
  src: PhotoDefault,
};

export default withImage(MosaicCardImage, true, PhotoDefault);
